import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { createRoutes, handleRecruiter, Loading, petitionSlugCanonicalRedirect } from 'src/app/shared/routes';

import { resolvePetitionL10nForBotsFromSlugParam } from './shared/resolvePetitionL10nForBotsFromSlugParam';

export const ROUTES: readonly AppRoute[] = [
	...createRoutes(
		{
			component: loadable(async () => import(/* webpackChunkName: "pages/petition_gamma" */ '../index'), {
				exportName: 'PetitionGammaStaffRoute',
				fallback: Loading,
			}),

			frame: {
				footer: true,
				header: true,
			},
		},
		[
			{
				id: 'petition-gamma-details',
				path: '/pgamma/:slug',
				restrictedAccess: {
					authOnly: true,
					role: 'staff',
				},
				// Duplicated from petition routes logic
				beforeServerRender: async (context) => {
					await handleRecruiter(context, context.params.slug);
					await petitionSlugCanonicalRedirect(context);
				},
				ssr: {
					enabled: true,
					seo: true,
					resolveL10n: resolvePetitionL10nForBotsFromSlugParam,
					config: ({ loginState }) => {
						if (loginState === 'GUEST') {
							return {
								disallowUserData: true,
								cache: {
									enabled: true,
									lifetimeInSeconds: 1 * 60, // 1min
									queryParams: ['expired_session'],
								},
							};
						}
						// avoid caching for non-guest
						// mainly so that starters see their changes right away
						return {};
					},
				},
			},
		],
	),
];
